import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Link } from '@calendly/ui/components/link';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade';
import { isRestrictedFeatureSelector } from 'features/billing';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
import { getTemplatesForTiles } from 'services/workflows/templates';
import { IntroText } from '../../../styles';
import { FlexHeadingSection, HeadingSubSection, HeaderImage } from '../../../styles/layout';
import { DisabledTemplatesList } from '../../../templates_list';
import { EmptyStateTitle } from '../../empty_state_title';
import { HeaderImageSource } from '../images';
import { UpgradeBanner } from '../upgrade_banner';
const headerRowCss = "h1jkbnnj";
const HeaderRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerRowCss, props.className)} />;
});
const actionRowIsPhoneCss = "a14by74l";
const actionRowCss = "a1vwfcec";
const ActionRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(actionRowCss, {
    [actionRowIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const DisabledState = ({
  bannerCopy
}) => {
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector);
  const upgradeIsRequired = useSelector(state => isRestrictedFeatureSelector(state, {
    featureKey: 'workflows'
  }));
  const enforceUpgrade = useEnforceUpgrade('workflows', {
    skipPreface: true,
    paywall: 'workflows_workflows_upgrade_btn_click',
    type: 'inline'
  });
  return <>
      <HeaderRow>
        <UpgradeBanner bannerCopy={bannerCopy} />
      </HeaderRow>
      <FlexHeadingSection>
        <HeadingSubSection>
          <HeaderRow>
            <EmptyStateTitle />
          </HeaderRow>
          <HeaderRow>
            <IntroText data-testid="workflows-intro-text">
              {I18n.t('publisher.workflows.empty_state.intro')}
            </IntroText>
          </HeaderRow>
          <ActionRow>
            {isOwnerOrAdmin && upgradeIsRequired && <Button size="large" onClick={enforceUpgrade}>
              {I18n.t('publisher.action.upgrade_now')}
            </Button>}
            <Link target="_blank" rel="noopener noreferrer" href="https://help.calendly.com/hc/en-us/articles/360051017814">
              {I18n.t('publisher.workflows.upgrade.learn_more')}
            </Link>
          </ActionRow>
        </HeadingSubSection>
        <HeadingSubSection>
          <HeaderImage src={HeaderImageSource} alt="" />
        </HeadingSubSection>
      </FlexHeadingSection>
      <DisabledTemplatesList templateIds={getTemplatesForTiles()} />
    </>;
};

require("./disabled_state.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./disabled_state.js");